import script from "./System_platform.vue?vue&type=script&setup=true&name=System_platform&lang=js"
export * from "./System_platform.vue?vue&type=script&setup=true&name=System_platform&lang=js"

import "./System_platform.vue?vue&type=style&index=0&id=0bb2fac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb2fac6"]])

export default __exports__